/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-29 09:22:45
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner, List, TextStyle, Link, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import {  ExternalMinor } from '@shopify/polaris-icons';

import { getShop } from 'src/helpers';
import { URL } from 'src/constants/links';
import { routes } from 'src/routes';

type Props = {
  onDismiss: Function,
  host: string
};

type ComposedProps = Props & WithI18nProps;

type State = {
  dismissedBanner: boolean
};

class HowToUse extends Component<ComposedProps, State> {
  state = {
    dismissedBanner: false
  };

  componentDidMount() {
    // Hide banner
    this.checkDismissedBanner();
  }

  render() {
    // const { onDismiss } = this.props;
    const { dismissedBanner } = this.state;
    const { i18n, host } = this.props;
    const shop = getShop();

    return !dismissedBanner ? (
      <Banner
        title={i18n.translate('AdminHTML.Recommendation.ManualRecommendation.HowToUse.bannerTitle')}
        status="info"
        onDismiss={this.onDismiss}>
        <TextStyle>
          {i18n.translate('AdminHTML.Recommendation.ManualRecommendation.HowToUse.subtitle', {
            t1: (
              <TextStyle variation="strong">
                {i18n.translate(
                  'AdminHTML.Recommendation.ManualRecommendation.HowToUse.subtitle_t1',
                  {
                    t: (
                      <span className="manual-external-link">
                        <Link
                          external
                          url={`${routes.recommendationWidgets.list()}?shop=${shop}&host=${host}`}>
                          {i18n.translate(
                            'AdminHTML.Recommendation.ManualRecommendation.HowToUse.subtitle_t1_t'
                          )}
                          <Icon source={ExternalMinor} color={'interactive'}></Icon>
                        </Link>
                      </span>
                    )
                  }
                )}
              </TextStyle>
            ),
            t2: (
              <Link external monochrome url={URL['RecommendationManualDoc']}>
                {i18n.translate(
                  'AdminHTML.Recommendation.ManualRecommendation.HowToUse.subtitle_t2'
                )}
              </Link>
            )
          })}
        </TextStyle>
        <br />
        <br />
        <TextStyle>
          {i18n.translate('AdminHTML.Recommendation.ManualRecommendation.HowToUse.paragraph')}
        </TextStyle>
        <List type="bullet">
          <List.Item>
            {i18n.translate(
              'AdminHTML.Recommendation.ManualRecommendation.HowToUse.list1_Content',
              {
                t: (
                  <TextStyle variation="strong">
                    {i18n.translate(
                      'AdminHTML.Recommendation.ManualRecommendation.HowToUse.list1_Content_t'
                    )}
                  </TextStyle>
                )
              }
            )}
          </List.Item>
          <List.Item>
            {i18n.translate(
              'AdminHTML.Recommendation.ManualRecommendation.HowToUse.list2_Content',
              {
                t: (
                  <TextStyle variation="strong">
                    {i18n.translate(
                      'AdminHTML.Recommendation.ManualRecommendation.HowToUse.list2_Content_t'
                    )}
                  </TextStyle>
                )
              }
            )}
          </List.Item>
        </List>
      </Banner>
    ) : null;
  }

  // Get dismissed banner status
  checkDismissedBanner = () => {
    const shop = getShop();
    let dismissed = false;
    try {
      dismissed = localStorage.getItem(`${shop}-dismissBannerInManualRecommendationPage`);
    } catch (error) {}

    if (dismissed === 'true') {
      this.setState({ dismissedBanner: true });
    }
  };

  // Handle hide banner
  onDismiss = () => {
    const shop = getShop();
    try {
      localStorage.setItem(`${shop}-dismissBannerInManualRecommendationPage`, `true`);
    } catch (error) {}

    // Hide banner
    this.setState({ dismissedBanner: true });
  };
}

export default withI18n()(HowToUse);
